import React from 'react';
import { config } from '@/config';
import MetaMaskSetupCard from './MetaMaskSetupCard';

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" style={{ background: '#1a1a1a' }}>
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="flex items-center justify-center mb-6">
            <img src="/heperum-logo.svg" className="h-10 brightness-0 invert" alt={config.appName} />
          </div>
          <h1 className="text-2xl font-bold text-white">{config.appName}</h1>
          <p className="text-sm text-gray-400">Earn {config.blockchain.tokenSymbol} coins for your time</p>
        </div>

        {/* Main Content */}
        <div className="bg-[#2a2a2a] border border-[#444] rounded-xl p-8">
          {children}
        </div>

        <MetaMaskSetupCard />

        {/* Footer */}
        <div className="text-center text-sm text-gray-500">
          <p>Powered by blockchain technology</p>
          <div className="mt-2 flex items-center justify-center space-x-4">
            <span>Chain ID: {config.blockchain.chainId}</span>
            <span>•</span>
            <span>{config.blockchain.tokenSymbol} Token</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;